import { useSnackbar } from "notistack"
import IconButton from "@mui/material/IconButton"
import React, { Fragment } from "react"

const useNotification = () => {
	const { enqueueSnackbar, closeSnackbar } = useSnackbar()
	const action = (key) => (
		<Fragment>
			<IconButton
				onClick={() => {
					closeSnackbar(key)
				}}
				variant="onlyIcon"
			>
				<i
					className="bi bi-x"
					style={{
						color: "white"
					}}
				/>
			</IconButton>
		</Fragment>
	)
	const setConf = (conf) => {
		if (conf?.msg) {
			enqueueSnackbar(conf.msg, {
				variant: conf.variant ? conf.variant : "info",
				autoHideDuration: !conf?.duration ? 5000 : conf?.duration,
				action: !conf?.showClose ? action : null
			})
		}
	}
	return setConf
}

export default useNotification
